import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface QuestionBankInitialState {
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
}

const initialState: QuestionBankInitialState = {
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    video_url: "video_na",
    widget_code: "question_generation",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        assessment_type: "hybrid",
        rubric_criteria: [
          "Successfully clear 1 question of each Bloom's Taxonomy",
          "Don't get rejected on 3 questions of Same Taxonomy consecutively",
        ],
        consider_history: false,
        custom_instructions: null,
        answer_viewed: [],
        question_count: 0,
        difficulty_level: "medium",
      },
      assessment_obj: {
        answer_viewed: [],
        question_count: 0,
      },
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: true,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const QuestionBankSlice = createSlice({
  name: "question-bank",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setAuditLogsHeartbeatStarted, setAuditLogsCompleteData, resetState } = QuestionBankSlice.actions

export default QuestionBankSlice.reducer
